import { TextField } from "@mui/material";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { TextAnswerSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/textAnswerSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: TextAnswerSubtypeDataModel;
}

export default function TextAnswerSubtypeDetails(props: Props) {
    return <>
        <TextField
            value={props.subtypeData.textAnswer}
            onChange={() => { }}
            multiline
            fullWidth />
    </>
}
